module.exports = __webpack_public_path__ + "media/IDcard.1b696149.mp4";